import type { FC } from 'react';
import React, { forwardRef, useEffect, useRef } from 'react';
import type { ModalProps } from '@americanexpress/dls-react';
import { Modal as DLSModal } from '@americanexpress/dls-react';

const Modal: FC<ModalProps> = forwardRef((props, ref) => {
  const yRef = useRef<number>(0);

  useEffect(() => {
    /* This solution is derived from this awesome CSS Tricks blog post:
     * https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open
     */
    const y = window.scrollY;
    yRef.current = y;
    document.body.style.overflowY = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.width = '100%';

    return () => {
      document.body.style.overflowY = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, yRef.current);
    };
  }, []);

  return <DLSModal {...props} ref={ref} />;
});
Modal.displayName = 'Modal'; // forwardRef does not maintain displayName

export default Modal;
